module.exports = __webpack_public_path__ + "img/logo.6bec98a1.png";